import React, { Component } from 'react';
import { HashRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import Header from '../common/template/header';
import SideBar from '../common/template/sideBar';
import Footer from '../common/template/footer';
import Messages from '../common/msg/messages';
import imagemLogo from '../assets/images/sologoamarela.png';
import imagemFundo from '../assets/images/logo_bemvindo.png';
import imagemBemVindo from '../assets/images/splash/bemvindo.png';

import imagemSplashTopo from '../assets/images/splash_acima.png';
import imagemSplashCentro from '../assets/images/splash_centro.png';
import imagemSplashAbaixo from '../assets/images/splash_abaixo.png';

import Routes from './routes';

class App extends Component {

	state = {
		carregando: true
	}

	constructor(props) {
		super(props);

		setTimeout(() => {
			this.setState({ ...this.state, carregando: false })
		}, 2000);
    }

	render() {
		
		return (
			<HashRouter>
				{this.state.carregando ?
					<div style={{ display: 'flex', alignItems: 'center', height: '100vh', backgroundSize: 'cover', background: '#ffffff' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column', 
								justifyContent: 'space-between',
								alignItems: 'center',
								height: '100%',
								width: '100%',
								backgroundSize: 'cover',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center'
							}}>
							<img src={imagemSplashTopo} style={{ width: '100%', maxHeight: 200, height: 'auto' }} />

							<img src={imagemSplashCentro} style={{ width: 400, height: 'auto' }} />

							<img src={imagemSplashAbaixo} style={{ width: '100%', maxHeight: 200, height: 'auto' }} />
						</div>
					</div>
				:
					<div className='wrapper'>
						<Header />
						{/* <SideBar /> */}
						<Routes />
						<Messages />
					</div>
				}
			</HashRouter>
		);
	}
}


const mapStateToProps = state => ({
	sessao: state.auth.usuario
});
export default connect(mapStateToProps, null)(App);
